import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/bg-frames/agence.module.scss';

const propTypes = {
    animate: PropTypes.bool,
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    animate: false,
    color: '#FF6633',
    className: null,
};

const Mission = ({ color, animate, className }) => (
    <svg
        width="841"
        height="631"
        viewBox="0 0 841 631"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classNames([styles.container, { [className]: className !== null, [styles.animate]: animate }])}
    >
        <path
            d="M530.02 385.03V630.03H830.02"
            stroke={color}
            strokeWidth="0.25"
            strokeMiterlimit="10"
            style={{
                transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                    animate ? 0 : Math.random() * 100 - 100
                }vw)`,
                opacity: `${animate ? 1 : 0}`,
            }}
        />
        <g className={styles.bar1}>
            <path
                d="M705.02 400.03H530.02V410.03H705.02V400.03Z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.bar2}>
            <path
                d="M675.02 415.03H530.02V425.03H675.02V415.03Z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.bar3}>
            <path
                d="M705.02 445.03H530.02V455.03H705.02V445.03Z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.bar4}>
            <path
                d="M740.02 460.03H530.02V470.03H740.02V460.03Z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.bar5}>
            <path
                d="M760.02 490.03H530.02V500.03H760.02V490.03Z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.bar6}>
            <path
                d="M695.02 505.03H530.02V515.03H695.02V505.03Z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.bar7}>
            <path
                d="M645.02 535.03H530.02V545.03H645.02V535.03Z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.bar8}>
            <path
                d="M650.02 550.03H530.02V560.03H650.02V550.03Z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.bar9}>
            <path
                d="M825.02 580.03H530.02V590.03H825.02V580.03Z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.pieChart}>
            <path
                d="M735.02 280.03C793.009 280.03 840.02 233.02 840.02 175.03C840.02 117.04 793.009 70.0298 735.02 70.0298C677.03 70.0298 630.02 117.04 630.02 175.03C630.02 233.02 677.03 280.03 735.02 280.03Z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    // transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                    //     animate ? 0 : Math.random() * 100 - 100
                    // }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M735.02 70.0298V175.03"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    // transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                    //     animate ? 0 : Math.random() * 100 - 100
                    // }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M679.381 85.9902L735.021 175.03"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    // transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                    //     animate ? 0 : Math.random() * 100 - 100
                    // }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M631.619 193.26L735.019 175.03"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    // transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                    //     animate ? 0 : Math.random() * 100 - 100
                    // }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
            <path
                d="M838.43 193.26L735.02 175.03"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    // transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                    //     animate ? 0 : Math.random() * 100 - 100
                    // }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
    </svg>
);

Mission.propTypes = propTypes;
Mission.defaultProps = defaultProps;

export default Mission;
